import { render, staticRenderFns } from "./AdminCode.vue?vue&type=template&id=6a36a9e1&scoped=true"
import script from "./AdminCode.vue?vue&type=script&lang=js"
export * from "./AdminCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a36a9e1",
  null
  
)

export default component.exports